import { z } from "zod";

import { API_VERSION } from "./common";

export const accountWriteSchema = z.object({
  name: z.string().trim().min(1).max(40),
  image: z.string().url().max(2048).nullable().optional(),
});

export const accountProfileSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().email(),
  image: z.string().nullable(),
});

export const accountResponseSchema = z.object({
  apiVersion: z.literal(API_VERSION),
  data: accountProfileSchema,
});

export const deleteAccountResponseSchema = z.object({
  apiVersion: z.literal(API_VERSION),
  data: z.object({ deleted: z.literal(true) }),
});

export type AccountWrite = z.input<typeof accountWriteSchema>;
export type ParsedAccountWrite = z.output<typeof accountWriteSchema>;
export type AccountResponse = z.infer<typeof accountResponseSchema>;
export type DeleteAccountResponse = z.infer<typeof deleteAccountResponseSchema>;
